import React from 'react'
// import Topoffcanvas from './Topoffcanvas'

function Cbsecard() {
    return (
        <div className="cbse-cus-card-box-parent my-4">
            <div className="container cbse-card-box">
                <div className="cus-card-box-heding my-2">

                    <h1> CBSE or ICSE Board Student ?</h1>
                    <p>Hey! Don't worry if you are an English medium Student, we have all the Notes,PYQ's & other resources in English also.</p>
                   
                    <button className=" btn-cbse-card" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">Grab Now !</button>
                </div>
                <div className="cbse-card-img-box">
                    <img src="./image/i05.jpg" alt="" className="cus-card-img" />
                </div>
            </div>
            {/* <Topoffcanvas title={"Sorry!"} description={"This section is under Maintenaince"}/> */}
        </div>

    )
}

export default Cbsecard